import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { problemDetail } from '@up2d8/api-client';
import { deniedRight, problemKind } from './problem-text';

/**
 * Een fout als zin voor het scherm (FBK-2): een ontbrekend recht met de naam van dat recht, iets
 * wat niet bestaat, of anders de melding van de server en pas dan `fallback`. Bij afgewezen invoer
 * zonder bruikbare uitleg (`VALIDATION_FAILED`) een algemene Nederlandse zin over de invoer, niet
 * `fallback`: "probeer het opnieuw" helpt daar niet (hertest 30 okt.).
 */
export function useProblemText() {
  const { t } = useTranslation();
  return useCallback(
    (error: unknown, fallback: string): string => {
      switch (problemKind(error)) {
        case 'denied': {
          const right = deniedRight(error);
          return right ? t('errors.deniedRight', { right }) : t('errors.policyDenied');
        }
        case 'notFound':
          return problemDetail(error) ?? t('errors.notFound');
        case 'invalid':
          return problemDetail(error) ?? t('errors.invalid');
        default:
          return problemDetail(error) ?? fallback;
      }
    },
    [t],
  );
}
